<template>
  <div class="inquiry-sheet-container">
    <van-form
      @submit="submitHandle"
      class="inquiry-sheet-form"
    >
      <div>
        <van-cell
          is-link
          @click="goHandle"
          v-model="formObjcet.healthRecordId"
          :rules="rules.healthRecordId"
        >
          <template #title>
            <span class="title">问诊人</span>
          </template>
          <template #default>
            <span
              class="value"
              v-if="_.has(healthRecord, 'id')"
            >
              {{ healthRecord.name || "" }}
            </span>
          </template>
        </van-cell>
      </div>
      <div>
        <van-cell>
          <template #title>
            <span class="title">病情描述</span>
          </template>
        </van-cell>
        <van-field
          name="diseaseDesc"
          v-model="formObjcet.diseaseDesc"
          :rules="rules.diseaseDesc"
          rows="5"
          autosize
          type="textarea"
          maxlength="500"
          placeholder="为了便于医生准确分析您的病情，请尽可能详细描述（10~500字）"
          show-word-limit
        />
      </div>
      
      <!-- <div>
            <van-cell>
                <template #title>
                    <span class="title">是否复诊?</span>
                </template>
            </van-cell>
            <van-field name="already">
                <template #input>
                    <van-radio-group
                        v-model="formObjcet.already"
                        direction="horizontal"
                    >
                        <van-radio :name="true">是</van-radio>
                        <van-radio :name="false">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <div class="prompt">
                注：根据互联网诊疗规定，只为已经就诊过的患者提供复诊以及在线开药。
            </div>
        </div> -->

      <div>
        <van-cell>
          <template #title>
            <span class="title">
              上传相关图片(病历、检验检查报告等)，最多8张
            </span>
          </template>
        </van-cell>
        <van-field name="annex">
          <template #input>
            <van-uploader
              v-model="formObjcet.annexList"
              :max-size="500 * 1024 * 10"
              :max-count="8"
              @oversize="onOversize"
              upload-icon="plus"
            />
          </template>
        </van-field>
      </div>
      <div>
        <van-field
          name="authorization"
          :rules="rules.authorization"
        >
          <template #input>
            <van-checkbox v-model="formObjcet.authorization">
              <template #default>
                <span
                  class="title"
                  clickable
                  @click.stop="authorizationHandle"
                >我已阅读并知晓</span>
                <span
                  class="agreement"
                  @click.stop="showPopup = !showPopup;"
                >《互联网医院服务协议》</span>
              </template>
            </van-checkbox>
          </template>
        </van-field>
      </div>
      <div class="prompt">
          注：根据互联网诊疗规定，只为已经就诊过的患者提供复诊以及在线开药。
      </div>
      
      <div class="tools">
        <van-button
          round
          block
          :loading="loading"
          :disabled="loading"
          size="small"
          type="primary"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>

    <van-dialog
      :before-close="onInquirySheetClose"
      v-model="showPopup"
      title="互联网医院就诊知情同意书"
      show-cancel-button
    >
      <div class="inquiry-sheet-notice">
        <div class="inquiry-sheet-notice-remind">欢迎您到{{organ.name}}互联网医院就诊，本互联网医院依托{{organ.name}}实体医院开展工作。我们愿意为您提供更为方便快捷的互联网就诊服务。为维护您的合法权益，请您仔细阅读以下内容。</div>
        <div class="inquiry-sheet-notice-content">
          <div>一、本互联网医院为已经在我院实体医院医院面诊的常见 病复诊患者和慢性病患者提供服务。如果您是初次就诊，请到实体医院就诊。急诊请到当地就近医院就诊。</div>
          <div>二、我们将提供1名具有相应诊疗服务能力、独立开展临床工作3年以上的执业医师为您提供互联网医疗服务。</div>
          <div>三、请您保证使用的手机、电脑或者其他终端设备能满足图像、声音、文字以及诊疗所需其他医疗信息的安全、实时传输，保证通话、视频清晰。</div>
          <div>四、为了保障您的健康及安全，同时保证诊疗过程顺利进行，请您一定提供或填写真实、详细、准确的资料，尤其是以前的病历和处方。如果病例复杂，请到实体医院就诊。</div>
          <div>五、未成年人需由监护人陪同下就诊，本医院不接受为低龄儿童（6岁以下）问诊。</div>
          <div>六、接诊医师可为您开具电子处方，您可选择第三方机构配送药品或在当地实体药房购药。电子处方不得开具麻醉药品、精神药品等特殊管理药品。</div>
          <div>七、由于医疗行业的特殊性，医生会利用医学知识和临床经 验对您当前这一时刻病情症状进行综合分析，尽可能地给出诊疗建议。局限于互联网就诊不能进行进行触诊实体检查、辅助诊断、治疗等客观原因，可能无法即时给您给具诊疗方案，此时请您及时面诊。</div>
          <div>八、您并未获得通过互联网医院服务达到百分之百确诊、获 取详细治疗方案、所患疾病确能治愈及好转的许诺。</div>
          <div>九、您同意承担因使用医疗服务所产生的费用及相关治疗 结果。</div>
          <div>十、本平台为常见病、慢性病的复诊患者提供正规实体医疗机构线上问诊服务，患者问诊时须按医生要求提供真实、详细、准确的病情资料和检验检查资料，以便于医生诊断，医生依据上述资料予以诊断。如因患者提供不实的信息和资料，导致的医疗风险将完全由用户承担；如果用户自行治疗或未完全遵循医嘱自服药品出现问题，本平台运营方和医疗机构不承担任何责任。</div>
          <div>十一、客服电话:{{organ.phone}}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import manageApi from '@/api/manageApi';
import paymentApi from '@/api/paymentApi';
import officialApi from '@/api/officialApi';

export default {
  data () {
    const rules = {
      diseaseDesc: [
        { required: true, message: '请输入病情描述' }
      ],
      authorization: [
        { required: true, message: '请阅读互联网医院服务协议' }
      ]
    }
    return {
      loading: false,
      healthRecord: {},
      showPopup: true,
      organ: {},
      inquirySheet: [],
      formObjcet: {
        healthRecordId: '',
        diseaseDesc: '',
        authorization: false,
        already: true,
        annexList: []
      },
      rules
    };
  },
  created () {
    this.init();
  },
  methods: {
    init () {
      manageApi.getDefaultHealthRecord().then(res => {
        this.healthRecord = res.data;
      }).catch(() => {

      });
      let organCode = this.organInfo.organCode;
      officialApi.queryMedicalOrgan(organCode).then(res => {
        this.organ = res.data[0];
      }).catch(() => {

      });
    },
    goHandle () {
      const { $router } = this;
      $router.push({
        path: '/manage/health_record_manage'
      });
    },
    onInquirySheetClose (action, done) {
      if ('confirm' === action)
        this.formObjcet.authorization = true;
      else
        this.formObjcet.authorization = false;
      done();
    },
    authorizationHandle () {
      this.formObjcet.authorization ? false : true;

    },
    submitHandle () {
      const { formObjcet, healthRecord, schedId, $toast, $router, $dialog } = this;
      if (!_.has(healthRecord, 'id')) {
        $toast('请选择问诊人');
        return;
      }
        
      if (!healthRecord.isFurtherVisit) {
        $toast('根据联网医院诊疗规定，只为已经就诊过的患者提供复诊以及在线开药，请到院诊疗。');
        return;
      }  
        
      let annexList = [];

      _.forEach(formObjcet.annexList, (item => {
        annexList.push(item.file);
      }));

      this.loading = true;
      paymentApi.createMedicalOder({
        ...formObjcet,
        schedId,
        annexList,
        healthRecordId: healthRecord.id
      }).then(res => {
        const data = res.data;
        $router.push({
          path: '/payment/payment_order',
          query: {
            transactionRecordId: data
          }
        });
      }).catch(res => {
        if (40001 === res.code) {
          $dialog.confirm({
            message: '您还有一笔未支付的订单，是否立即前往支付？',
            beforeClose: (action, done) => {
              if (action === 'confirm') {
                const data = res.data;
                $router.push({
                  path: '/payment/payment_order',
                  query: {
                    transactionRecordId: data
                  }
                });
                done();
              } else {
                done();
              }
            }
          });
        }
      }).finally(() => {
        this.loading = false;
      });

    },
    onOversize (file) {
      this.$toast('文件大小不能超过 5MB');
    },
  },
  computed: {
    organInfo () {
      return this.$hdk.data(this.$setter.organInfo);
    }
  },
  props: {
    schedId: {
      type: String,
      required: true
    }
  }
}
</script>


<style lang="less" scoped>
.inquiry-sheet-container {
  margin-bottom: 1.6rem;
}

.inquiry-sheet-form > div:not(:first-child) {
  margin-top: 0.4rem;
}

.tools {
  position: fixed;
  bottom: 0;
  padding: 0.213333rem 0.48rem;
  background-color: @white-color;
  left: 0;
  right: 0;
  height: 0.933333rem;
  box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
}

.title {
  color: @grey-color;
}

.value {
  color: @black-color;
  font-weight: 600;
}

.agreement {
  font-size: 0.32rem;
  color: @primary-color;
}

.prompt {
  padding: 0.08rem 0.266667rem;
  color: @grey-color;
  font-size: 0.373333rem;
}

.inquiry-sheet-notice {
  padding: 0.26rem 0.4rem;
  font-size: 0.32rem;
  max-height: 8.5rem;
  overflow-y: auto;
}

.inquiry-sheet-notice .inquiry-sheet-notice-remind {
  color: var(--red);
  line-height: 0.58rem;
  margin: 0.13rem 0;
  text-indent: 2em;
}

.inquiry-sheet-notice .inquiry-sheet-notice-content {
  line-height: 0.58rem;
  margin: 0.13rem 0;
}
</style>